import StaticAnalysis from "./StaticAnalysis.model";
import { staticLayerTypes } from ".";

/**
 * TimeSpent Layer class for static entities
 * This model is used to represent the TimeSpent Analysis in the
 * static entity analysis console.
 *
 * The analysis is based on two distinct event happening within a static entity.
 */
export default class TimeSpent extends StaticAnalysis {
  /**
   *
   * @param {Object} param
   * @param {String} param.id id of the layer
   * @param {String} param.name Name of the layer
   * @param {Object} param.static_entity Static entity object
   * @param {Object} param.entity Selected entity
   * @param {Object} param.start_event Start event of the analysis
   * @param {Object} param.end_event End Event of the analysis
   */
  constructor({ id, name, static_entity, entity, start_event, end_event }) {
    super({ type: staticLayerTypes.TIME_SPENT, id, name, static_entity });
    this.entity = entity;
    this.start_event = start_event;
    this.end_event = end_event;
    this.component = "TimeSpentLayer";
  }
}
